import { render, staticRenderFns } from "./divideItem.vue?vue&type=template&id=21668b58&"
import script from "./divideItem.vue?vue&type=script&lang=js&"
export * from "./divideItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports